import axiosInstance from "./AxiosConfig";

export const submitObtainFinancingApi = async data => axiosInstance.post("/google-api/obtain-financing", data);
